// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2476 ? "4c752c74" : chunkId) + "." + {"1292":"d4bd7ab6ea213c01","2476":"5df7e1e8968c3f65","7365":"1064cb901be151ac"}[chunkId] + ".js";
};